import DecoyLogo from "../assets/images/logo.png";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
import SocialLinks from './socials';

const HeaderNav = () => {
    return (  
        <Navbar collapseOnSelect expand="lg" variant="dark" static="top">
            <Container>
                <Navbar.Brand href="/"><img src={DecoyLogo} alt="Decoy" height="60"/></Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto ms-auto">
                            <Link to="/home" className="nav-link">Home</Link>
                         
                        </Nav>
                        <Nav className="socials">
                        <SocialLinks type="icon"/>
                         </Nav>
                    </Navbar.Collapse>
            </Container>
      </Navbar>   
    );
}
 
export default HeaderNav;